export const RESOURCES = {
  Journey: {
    slug: {
      singular: 'journey',
      plural: 'journeys'
    },
    humanName: {
      singular: 'Jornada',
      plural: 'Jornadas'
    },
    basePath: '/jornadas',
    getResourcePath: ({ resource }) => `/jornadas/${resource?.uid}`
  },
  Level: {
    slug: {
      singular: 'level',
      plural: 'levels'
    },
    humanName: {
      singular: 'Nível',
      plural: 'Níveis'
    },
    getResourcePath: ({ resource }) => `/niveis/${resource?.uid}/iniciar`
  },
  Mission: {
    slug: {
      singular: 'mission',
      plural: 'missions'
    },
    humanName: {
      singular: 'Missão',
      plural: 'Missões'
    },
    basePath: '/missoes',
    getResourcePath: ({ resource }) => `/missoes/${resource?.uid}`
  },
  Document: {
    slug: {
      singular: 'document',
      plural: 'documents'
    },
    humanName: {
      singular: 'Documento',
      plural: 'Documentos'
    },
    basePath: '/documentos',
    finishedPathOnProgress: 'finished_documents'
  },
  Post: {
    slug: {
      singular: 'post',
      plural: 'posts'
    },
    humanName: {
      singular: 'Postagem',
      plural: 'Postagems'
    },
    basePath: '/feed',
    finishedPathOnProgress: 'finished_posts',
    pointsRewardPathOnConfig: 'posts_config.posts_point_reward',
    coinsRewardPathOnConfig: 'posts_config.posts_coin_reward',
    acquiredPointsPathOnProgress: 'aquired_points_and_coins.posts_points',
    acquiredCoinsPathOnProgress: 'aquired_points_and_coins.posts_coins'
  },
  Reward: {
    slug: {
      singular: 'reward',
      plural: 'rewards'
    },
    humanName: {
      singular: 'Recompensa',
      plural: 'Recompensas'
    },
    basePath: '/lojinha'
  },
  Programming: {
    slug: {
      singular: 'programming',
      plural: 'programmings'
    },
    humanName: {
      singular: 'Programação',
      plural: 'Programações'
    },
    basePath: '/programacao',
    getResourcePath: ({}) => '/programacao'
  },
  Partner: {
    slug: {
      singular: 'partner',
      plural: 'partners'
    },
    humanName: {
      singular: 'Parceiro',
      plural: 'Parceiros'
    },
    basePath: '/parceiros',
    // Deep link de blocker e de QR code carrega o que o payload tinha à mão —
    // slug, uid ou id. A página do parceiro aceita os três e traduz para o slug
    // que o show da API exige (`find_by: :slug`).
    getResourcePath: ({ resource }) => {
      const identifier = resource?.slug || resource?.uid || resource?.id
      if (!identifier) return '/parceiros'

      return `/parceiros/${encodeURIComponent(String(identifier))}`
    }
  },
  Quest: {
    slug: {
      singular: 'quest',
      plural: 'quests'
    },
    humanName: {
      singular: 'Quest',
      plural: 'Quests'
    },
    basePath: '/quests',
    getResourcePath: ({ resource }) => `/quests/${resource?.uid}`
  },
  Bonus: {
    slug: {
      singular: 'bonus',
      plural: 'bonuses'
    },
    humanName: {
      singular: 'Bônus',
      plural: 'Bônus'
    },
    basePath: '/bonus',
    getResourcePath: ({ resource }) => {
      const uid = resource?.uid
      if (!uid) return undefined

      const partnerId = resource?.partner_id
      if (partnerId == null) return `/bonus/${uid}`

      return `/bonus/${uid}?partnerId=${partnerId}`
    }
  },
  BonusPartner: {
    slug: {
      singular: 'bonus_partner',
      plural: 'bonus_partners'
    },
    humanName: {
      singular: 'Bônus',
      plural: 'Bônus'
    },
    basePath: '/bonus',
    getResourcePath: ({ resource }) => {
      const uid = resource?.uid
      if (!uid) return undefined

      const partnerId = resource?.partner_id
      if (partnerId == null) return `/bonus/${uid}`

      return `/bonus/${uid}?partnerId=${partnerId}`
    }
  },
  // O polimórfico do Rails guarda o nome real da classe (`GamificationPage`)
  // como resource_type, não o rótulo "CustomPages" que o webapp usa só na
  // UI do produtor (@common/Resource/config.ts) — chave aqui precisa bater
  // com o valor que a api de fato envia.
  GamificationPage: {
    slug: {
      singular: 'gamification_page',
      plural: 'gamification_pages'
    },
    humanName: {
      singular: 'Módulo',
      plural: 'Módulos da Navegação'
    },
    basePath: '/p',
    getResourcePath: ({ resource }) =>
      resource?.slug ? `/p/${resource.slug}` : undefined
  }
}

export const getResource = (resourceKey: string) => {
  if (!resourceKey) throw new Error('Resource key not provided')
  const keyNormalized = resourceKey.trim().toLowerCase()

  let found = Object.entries(RESOURCES).find(
    ([key]) => key.toLowerCase() === keyNormalized
  )
  if (found) return found[1]

  let found2 = Object.values(RESOURCES).find(resource => {
    const { slug } = resource
    return (
      slug?.singular?.toLowerCase() === keyNormalized ||
      slug?.plural?.toLowerCase() === keyNormalized
    )
  })
  if (found2) return found2

  let found3 = Object.values(RESOURCES).find(resource => {
    const { humanName } = resource
    return (
      humanName?.singular?.toLowerCase() === keyNormalized ||
      humanName?.plural?.toLowerCase() === keyNormalized
    )
  })
  if (found3) return found3

  throw new Error(`Resource ${resourceKey} not found`)
}
